import classNames from 'classnames'
import React from 'react'

const ButtonSelect = ({name, values, header}) => {

    const headerTitleClass = classNames({
        'headerTitle': true,
        'small': values[name],
        'big': !values[name]
    })

    return (
        <button  type='button' value={values[name]}>
            <div
                className={headerTitleClass}
            >
                {header}
            </div>
                {values[name] &&
                    <div className="headerValue">
                        {values[name]}
                    </div>
                }
        </button>
    )
}

export default ButtonSelect